import i18n, { BackendModule, ReadCallback } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { loadLang } from "virtual:lang";

const MyBackend: BackendModule = {
    type: 'backend',
    init() {
    },
    read(language, namespace, callback) {
        console.log(`Loading language bundle for: ${language}, namespace: ${namespace}`);
        loadLang(language)
            .then((bundle) => callback(null, bundle))
            .catch((err) => callback(err, false));
    }
}

await i18n
    // If using React, pass the plugin:
    .use(MyBackend)
    .use(LanguageDetector)
    .use(initReactI18next)

    // Initialize with your config
    .init({
        resources: {
        },
        fallbackLng: 'en',
        partialBundledLanguages: true,
        interpolation: {
            escapeValue: false, // React already does XSS protection
        },
        detection: {
            lookupCookie: 'locale',
        },
    });

if (import.meta.hot) {
  import.meta.hot.accept('virtual:lang/fr', (newMod) => {
    console.log("asfd");
    i18n.reloadResources();
  });
}

// noinspection JSUnusedGlobalSymbols
export default i18n;
